import { useEffect } from 'react';

export function useMouseTilt(ref, strength = 12) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    
    let raf = 0;
    let tx = 0, ty = 0, cx = 0, cy = 0;
    
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      const px = (e.clientX - (r.left + r.width / 2)) / r.width;
      const py = (e.clientY - (r.top + r.height / 2)) / r.height;
      tx = px * strength;
      ty = py * strength;
      if (!raf) raf = requestAnimationFrame(loop);
    };
    
    const loop = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      el.querySelectorAll("[data-tilt]").forEach(node => {
        const depth = parseFloat(node.dataset.tilt || "1");
        node.style.transform = `translate3d(${(cx * depth).toFixed(2)}px, ${(cy * depth).toFixed(2)}px, 0)`;
      });
      if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) {
        raf = requestAnimationFrame(loop);
      } else {
        raf = 0;
      }
    };
    
    window.addEventListener("mousemove", onMove);
    
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [ref, strength]);
}
